class BeedoCategoryNavigation extends HTMLElement {
  #events;
  connectedCallback() {
    this.#events?.abort();
    this.#events = new AbortController();
    const options = { signal: this.#events.signal };
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-category-toggle]');
      if (!button) return;
      const item = button.closest('[data-category-item]');
      this.#open(button.getAttribute('aria-expanded') === 'true' ? null : item);
    }, options);
    this.addEventListener('pointerover', event => {
      if (!matchMedia('(min-width: 750px) and (hover: hover)').matches) return;
      const item = event.target.closest('[data-category-item]');
      if (item) this.#open(item);
    }, options);
    this.addEventListener('pointerleave', () => {
      if (matchMedia('(min-width: 750px) and (hover: hover)').matches && !this.contains(document.activeElement)) this.#open(null);
    }, options);
    this.addEventListener('focusout', event => {
      if (!this.contains(event.relatedTarget)) this.#open(null);
    }, options);
    this.addEventListener('keydown', event => {
      const item = event.target.closest('[data-category-item]');
      if (event.key === 'Escape') {
        const active = this.querySelector('[data-category-toggle][aria-expanded="true"]');
        this.#open(null);
        active?.focus();
        event.preventDefault();
      } else if (event.key === 'ArrowDown' && item && event.target.closest('.bc-nav__trigger')) {
        this.#open(item);
        item.querySelector('[data-category-panel] a')?.focus();
        event.preventDefault();
      }
    }, options);
    document.addEventListener('pointerdown', event => {
      if (!this.contains(event.target)) this.#open(null);
    }, options);
    window.addEventListener('resize', () => this.#open(null), options);
  }
  disconnectedCallback() { this.#events?.abort(); }
  #open(selected) {
    for (const item of this.querySelectorAll('[data-category-item]')) {
      const expanded = item === selected;
      item.querySelector('[data-category-toggle]').setAttribute('aria-expanded', String(expanded));
      item.querySelector('[data-category-panel]').hidden = !expanded;
    }
  }
}
if (!customElements.get('beedo-category-navigation')) customElements.define('beedo-category-navigation', BeedoCategoryNavigation);
